module.exports = __webpack_public_path__ + "img/deposit3.2a13d517.jpg";